import React from 'react';

const Integrations = () => {
  const integrations = [
    {
      title: 'Branded Portal',
      description: 'Launch a fully-hosted compliance portal with your a branding — no development required.',
      features: [
        'White-labelled resident portal',
        'Custom domain and branding',
        'Mobile-responsive design',
        'Complete audit trail for compliance reporting'
      ]
    },
    {
      title: 'API Integration',
      description: 'Build custom workflows with our RESTful API and real-time webhooks.',
      features: [
        'Full API access',
        'Real-time webhook notifications',
        'Custom business logic',
        'Developer documentation'
      ]
    },
    {
      title: 'Program Management',
      description: 'Native integrations with leading property management systems.',
      features: [
        'Bi-directional data sync',
        'Automated charge posting',
        'Lease event triggers',
        'Enterprise-grade reliability'
      ]
    }
  ];


  return (
    <section className="integrations-wrapper">
      {/* Vertical Dividers */}
      <div className="integrations-divider integrations-divider-1"></div>
      <div className="integrations-divider integrations-divider-2"></div>
      <div className="integrations-divider integrations-divider-3"></div>
      <div className="integrations-divider integrations-divider-4"></div>
      <div className="integrations-divider integrations-divider-5"></div>

      {/* Title Section */}
      <div className="integrations-title-section">
        <h2 className="integrations-title">Powerful Integrations</h2>
        <p className="integrations-description">
          Choose the integration approach that works best for your organization.
        </p>
      </div>

      {/* Integration Cards - Single Row */}
      <div className="integrations-row integrations-row-1">
        <div className="integration-card integration-card-1">
          <div className="integration-card-content">
            <div className="integration-card-title">{integrations[0].title}</div>
            <div className="integration-card-text">
              <span className="integration-card-description">{integrations[0].description}<br/><br/></span>
              <span className="integration-card-features">
                {integrations[0].features.map((feature, idx) => (
                  <React.Fragment key={idx}>
                    {feature}
                    {idx < integrations[0].features.length - 1 && <br/>}
                  </React.Fragment>
                ))}
              </span>
            </div>
          </div>
        </div>
        <div className="integration-card integration-card-2">
          <div className="integration-card-content">
            <div className="integration-card-title">{integrations[1].title}</div>
            <div className="integration-card-text">
              <span className="integration-card-description">{integrations[1].description}<br/><br/></span>
              <span className="integration-card-features">
                {integrations[1].features.map((feature, idx) => (
                  <React.Fragment key={idx}>
                    {feature}
                    {idx < integrations[1].features.length - 1 && <br/>}
                  </React.Fragment>
                ))}
              </span>
            </div>
          </div>
        </div>
        <div className="integration-card integration-card-3">
          <div className="integration-card-content">
            <div className="integration-card-title">{integrations[2].title}</div>
            <div className="integration-card-text">
              <span className="integration-card-description">{integrations[2].description}<br/><br/></span>
              <span className="integration-card-features">
                {integrations[2].features.map((feature, idx) => (
                  <React.Fragment key={idx}>
                    {feature}
                    {idx < integrations[2].features.length - 1 && <br/>}
                  </React.Fragment>
                ))}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Corner Indicators */}
      <div className="integrations-corner integrations-corner-1"></div>
      <div className="integrations-corner integrations-corner-2"></div>
      <div className="integrations-corner integrations-corner-3"></div>
      <div className="integrations-corner integrations-corner-4"></div>
    </section>
  );
};

export default Integrations;
